import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { DELETE_GROUP_VERSION_MUTATION } from "../../../../graphql/mutations";

const DeleteGroupVersionModal = ({ show, groupVersion, handleClose, handleEnvChange, env, tenantName, tenantId }) => {
  const navigate = useNavigate();
  const [deleteGroupVersion, { loading: mutationLoading }] = useMutation(DELETE_GROUP_VERSION_MUTATION);

  const handleDeleteGroupVersion = async () => {
    try {
      const { data } = await deleteGroupVersion({
        variables: {
          id: groupVersion.id
        }
      });

      if (data?.deleteGroupVersion) {
        handleClose();
        setTimeout(() => {
          toast.success("Group version deleted successfully.");
          navigate("/group-versions");
          handleEnvChange(env, tenantId, tenantName);
        }, 200);
      }
    } catch (error) {
      handleClose();
      setTimeout(() => {
        toast.error("Failed to delete group version.");
        console.error("Delete error:", error);
      }, 200);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton className="d-flex justify-content-center">
        <Modal.Title className="w-100 text-center">Delete Group Version</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-center">
          Are you sure you want to delete the group version for <strong>{groupVersion.name}</strong> from year{" "}
          <strong>{groupVersion.ogmpYear}</strong>?
        </p>
        <p className="text-center text-danger"> This action cannot be undone and may affect associated data.</p>
        <div className="d-flex justify-content-center mt-4">
          <Button variant="primary" onClick={handleClose} className="me-2">
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDeleteGroupVersion} disabled={mutationLoading}>
            {mutationLoading ? "Deleting..." : "Delete"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export { DeleteGroupVersionModal };
